import { ConsultaSeguimentoIndicatorResultado } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoIndicatorResultado'
import { ConsultaSeguimentoIndicatorStart } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoIndicatorStart'
import { ConsultaSeguimentoPerguntaHeader } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoPerguntaHeader'
import { ConsultaSeguimentoPerguntaHeaderTitle } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoPerguntaHeaderTitle'
import { PerguntaSimNaoRadioGroupBoxField } from '@mchat-rf/consulta-seguimento/components/PerguntaSimNaoRadioGroupBoxField'
import { isPerguntaStatusRespondendo } from '@mchat-rf/consulta-seguimento/consulta-seguimento-aplicacao/utils-consultaSeguimentoAplicacao'
import { useConsultaSeguimentoAutoScroll } from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { useConsultaSeguimentoSetResultado } from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoSetResultado'
import { VFlow } from 'bold-ui'
import { resolveName, SimNaoEnum } from 'components/form'
import { SimNaoSwitchButtonField } from 'components/form/field/SimNaoSwitchButtonField'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { RefObject } from 'react'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoPergunta13Model } from './model-consultaSeguimentoPergunta13'
import { PERGUNTA_13_SCROLL_CONFIG } from './scrollConfig-consultaSeguimentoPergunta13'
import { calculateResultadoPergunta13, conditionToCalculatePergunta13 } from './utils-consultaSeguimentoPergunta13'

interface ConsultaSeguimentoPergunta13FieldProps {
  name: MetaPath<ConsultaSeguimentoPergunta13Model>
  containerRef: RefObject<HTMLDivElement>
  goNextButtonRef: RefObject<HTMLButtonElement>
}

export function ConsultaSeguimentoPergunta13Field(props: Readonly<ConsultaSeguimentoPergunta13FieldProps>) {
  const { name, containerRef, goNextButtonRef } = props

  const {
    input: { value },
  } = useField<ConsultaSeguimentoPergunta13Model>(resolveName(name), {
    subscription: { value: true },
  })

  useConsultaSeguimentoSetResultado<ConsultaSeguimentoPergunta13Model>({
    name,
    conditionToCalculate: conditionToCalculatePergunta13,
    calculateResultado: calculateResultadoPergunta13,
  })

  const { getId, triggerScrollFor } = useConsultaSeguimentoAutoScroll<ConsultaSeguimentoPergunta13Model>({
    name,
    containerRef,
    goNextButtonRef,
    scrollConfig: PERGUNTA_13_SCROLL_CONFIG,
  })

  return (
    <VFlow vSpacing={0}>
      <VFlow>
        {isPerguntaStatusRespondendo(value.status) && (
          <ConsultaSeguimentoPerguntaHeader
            pergunta={MChatPerguntaEnum.PERGUNTA_13}
            title={<ConsultaSeguimentoPerguntaHeaderTitle sufix=' anda?' />}
            status={value.status}
            field={
              <SimNaoSwitchButtonField
                name={name.PERGUNTA_13_HEADER}
                onChange={() => triggerScrollFor('PERGUNTA_13_HEADER')}
              />
            }
          />
        )}
        {value?.PERGUNTA_13_HEADER === SimNaoEnum.SIM && (
          <VFlow vSpacing={0} id={getId('PERGUNTA_13_ANDA_SEM_APOIO')}>
            <ConsultaSeguimentoIndicatorStart />
            <PerguntaSimNaoRadioGroupBoxField
              name={name.PERGUNTA_13_ANDA_SEM_APOIO}
              label='Anda sem se segurar ou sem se apoiar em algo?'
              required
              onChange={() => triggerScrollFor('PERGUNTA_13_ANDA_SEM_APOIO')}
            />
          </VFlow>
        )}
      </VFlow>
      {value?.resultado && <ConsultaSeguimentoIndicatorResultado resultado={value.resultado} />}
    </VFlow>
  )
}
